import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { UserModel } from '../../../_models/user.model';
import { environment } from '../../../../../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
const API_USERS_URL = `${environment.apiUrl}/users`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) { }
  getUserByToken(token: string): Observable<UserModel> {
    const helper = new JwtHelperService();
    const authData = helper.decodeToken(sessionStorage.getItem('jwtToken'));
    if (!authData) {
      return of(undefined);
    }
    return of(authData);
  }
}
